<ul *ngIf="countPages > 0" class="uk-pagination uk-flex-right uk-flex-center@m">
	<li>
		<a *ngIf="currentPage > 1" href="#" (click)="changePage(currentPage - 1, $event)">
			<span class="IconItem IconItem--PagArrowLeft">
				<img src="/assets/img/icon/pag-arrow-left.svg" uk-svg>
			</span>
		</a>
	</li>

	<li *ngFor="let page of pages"
		class="uk-pagination-page"
		[ngClass]="page.active ? 'uk-active' : ''">
		<span *ngIf="page.active">{{page.num}}</span>
		<a *ngIf="!page.active" href="#" (click)="changePage(page.num, $event)">{{page.num}}</a>
	</li>

	<!-- <li class="uk-disabled">
		<span class="IconItem IconItem--Ellipsis">
			<img src="/assets/img/icon/ellipsis.svg" uk-svg>
		</span>
	</li> -->

	<li>
		<a *ngIf="currentPage !== countPages" href="#" (click)="changePage(currentPage + 1, $event)">
			<span class="IconItem IconItem--PagArrowRight">
				<img src="/assets/img/icon/pag-arrow-right.svg" uk-svg>
			</span>
		</a>
	</li>
</ul>
